import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
import VeltCommentDialogVisibilityDropdownContentPublicWireframe from './VeltCommentDialogVisibilityDropdownContentPublicWireframe/VeltCommentDialogVisibilityDropdownContentPublicWireframe';
import VeltCommentDialogVisibilityDropdownContentPrivateWireframe from './VeltCommentDialogVisibilityDropdownContentPrivateWireframe/VeltCommentDialogVisibilityDropdownContentPrivateWireframe';
;
var VeltCommentDialogVisibilityDropdownContentWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-visibility-dropdown-content-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogVisibilityDropdownContentWireframe.Public = VeltCommentDialogVisibilityDropdownContentPublicWireframe;
VeltCommentDialogVisibilityDropdownContentWireframe.Private = VeltCommentDialogVisibilityDropdownContentPrivateWireframe;
export default VeltCommentDialogVisibilityDropdownContentWireframe;
